<template>
  <div class="d-flex align-center" style="margin-top: 25px; margin-bottom: 15px;">
      <v-btn icon :disabled="isPrevMonthDisabled" @click="onPrevMonth()">
        <v-icon color="grey darken-1">arrow_back</v-icon>
      </v-btn>
      <v-menu
        ref="menu"
        v-model="showDatePicker"
        :close-on-content-click="false"
        :return-value.sync="date"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <span class="mx-4" v-bind="attrs" v-on="on">
            <a 
              ref="monthLink" 
              style="text-decoration: underline; text-underline-offset: 2px; color: #185EA9 !important;" 
              @click.stop="openDatePicker()">
              {{ year ? getLongMonthNameWithYear(month, year).toUpperCase() : '' }}
            </a>
          </span>
        </template>
        <v-date-picker
          v-model="date"
          no-title
          scrollable
          :locale="$i18n.locale"
          :min="`${years[0]}-01-01`"
          :max="`${years[years.length - 1]}-12-31`"
          :first-day-of-week="1"
        >        
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="moveToToday()"
          >
            {{ $t('wkt.admin.projects.calendar.datepicker.today') }}
          </v-btn>
        </v-date-picker>
      </v-menu>
      <v-btn icon :disabled="isNextMonthDisabled" @click="onNextMonth()">
        <v-icon color="grey darken-1">arrow_forward</v-icon>
      </v-btn>

      <v-text-field
        ref="employee" 
        v-model="employee"
        :label="$t('wkt.admin.projects.calendar.filter.search_employee')"
        hide-details
        :clearable="true"
        @click:clear="onEmployeeClearedTimeOut()"
        @keyup="onEmployeeChangedTimeOut()"
        style="margin-top: -20px; margin-left: 20px; max-width: 150px; width: 150px;" 
      />
  </div>
</template>

<script>
import BaseModule from '../../common/BaseModule';

export default {
	name: 'ProjectCalendarMonthlyFilters',
	mixins: [BaseModule],
	data () {
		return {
      year: null,
      month: null,
      years: [],
      employee: null,
      timer: null,
      showDatePicker: false,
      date: new Date().toISOString(),
		}
	},
  computed: {
    isPrevMonthDisabled() {
      if (!this.year || this.years.length === 0) {
        return true;
      }
      return this.year === this.years[0] && this.month === 1;
    },
    isNextMonthDisabled() {
      if (!this.year || this.years.length === 0) {
        return true;
      }
      return this.year === this.years[this.years.length - 1] && this.month === 12;      
    }
  },
	methods: {
    init(startYear, currentYear, currentMonth) {
      this.years = [];

      const start = new Date(startYear, currentMonth - 1, 1);
      const finish = this.addMonthsToDate(new Date(), 6);

      const numYears = finish.getFullYear() - start.getFullYear();
      let year = start.getFullYear();

      for (let i = 0; i <= numYears; i++) {
        this.years.push(year);
        year++;
      }

			this.year = currentYear;
      this.month = currentMonth;
    },
    filterChanged() {
      const fromDate = this.getFirstDayOfMonth(this.month, this.year);
      const toDate = this.getLastDayOfMonth(this.month, this.year);
      const employee = !this.employee || this.employee.trim().length === 0 ? null : this.employee;

			this.$emit('updated', { fromDate: fromDate, toDate: toDate, employee: employee });
    },
    onYearChanged() {
      this.filterChanged();
    },
    onPrevMonth() {
      if (this.month > 1) {
        this.month--;
      } else {
        if (this.year <= this.years[0]) {
          return;
        }
        this.year--;
        this.month = 12;
      }

      this.filterChanged();
    },
    onNextMonth() {
      if (this.month < 12) {
        this.month++;
      } else {
        if (this.year >= this.years[this.years.length - 1]) {
          return;
        }
        this.year++;
        this.month = 1;
      }
      
      this.filterChanged();
    },
    onEmployeeClearedTimeOut() {
      this.employee = null;
      this.$refs.employee.blur();
      this.onEmployeeChangedTimeOut();
    },
    onEmployeeChangedTimeOut() { 
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.filterChanged();
      }, 800);
    },
    openDatePicker() {
      this.date = this.getFirstDayOfMonth(this.month, this.year).toISOString();

      this.$nextTick(function() {
        this.showDatePicker = true;
      });
    },
    moveToToday() {
      this.date = new Date().toISOString();

      this.$nextTick(function() {
        this.showDatePicker = false;
      });
    },
    getPeriod() {
      return this.getLongMonthNameWithYear(this.month, this.year).toUpperCase();
    },
	},
  watch: {
    // eslint-disable-next-line no-unused-vars
    date (newValue, oldValue) {    
      if (this.showDatePicker) {
        this.showDatePicker = false;
        
        const [year, month] = newValue.split("-");
        this.year = parseInt(year);
        this.month = parseInt(month);
      
        this.filterChanged();
      }
    },
  },
}
</script>